import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from "element-plus";
import 'element-plus/dist/index.css'
import Countdown from 'vue3-flip-countdown'
import i18n from './i18n'

createApp(App).use(i18n).use(ElementPlus).use(Countdown).mount('#app')
